import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b383bdc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "inner" };
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'full_width_video',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const vimeoPlayer = ref(null);
        onMounted(() => {
            if (vimeoPlayer.value) {
                const player = new Vimeo.Player(vimeoPlayer.value, {
                    id: props.d.vimeo_id,
                    color: '#FF5317',
                    responsive: true,
                    autoplay: true,
                    controls: false,
                    loop: true,
                    muted: true,
                    quality: '4k',
                });
            }
        });
        return (_ctx, _cache) => {
            const _component_smart_text = _resolveComponent("smart-text");
            return (_openBlock(), _createBlock(_component_smart_text, {
                class: "full_width_video",
                style: _normalizeStyle(`background-color: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`)
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (props.d.vimeo_id)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                ref_key: "vimeoPlayer",
                                ref: vimeoPlayer
                            }, null, 512))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 1
            }, 8, ["style"]));
        };
    }
});
